import { render, staticRenderFns } from "./AccountingIvaModal.vue?vue&type=template&id=30bb0c64&scoped=true&"
import script from "./AccountingIvaModal.vue?vue&type=script&lang=js&"
export * from "./AccountingIvaModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountingIvaModal.vue?vue&type=style&index=0&id=30bb0c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bb0c64",
  null
  
)

export default component.exports